module.exports = __webpack_public_path__ + "static/media/data_siswa.316ac0b8.png";